import styled from "styled-components";
import { DataGridCell, Main, color, palette } from "@conserveit/blocks";

export const ActionedCell = styled(DataGridCell)`
  background-color: ${palette.neutral2} !important;
`;
export const ActionedMain = styled(Main)`
  color: ${color.theme.typography.subdued};
`;
